import {
  getPreferences,
  removePreferences,
  setPreferences,
} from '@/utils/preferences'

import { BranchDataParams } from '@/enums'

// Set branch referral data to preferences
export const setLocalReferralData = (
  branchDesktopUrl: string,
  branchRefUsername: string
) => {
  if (branchRefUsername && branchDesktopUrl) {
    setPreferences({
      key: BranchDataParams.RefUsername,
      value: branchRefUsername,
    })
    setPreferences({
      key: BranchDataParams.DesktopUrl,
      value: branchDesktopUrl,
    })
  }
}

// Get referral data from preferences
export const getLocalReferralData = async () => {
  const localDesktopUrl = await getPreferences(BranchDataParams.DesktopUrl)
  const localRefUsername = await getPreferences(BranchDataParams.RefUsername)
  return {
    localDesktopUrl,
    localRefUsername,
  }
}

// By default, the initial data of Branch is read, otherwise it is read from preferences
export const getReferralParamData = async (
  branchDesktopUrl: string,
  branchRefUsername: string
) => {
  const { localDesktopUrl, localRefUsername } = await getLocalReferralData()
  const desktopUrl = branchDesktopUrl || localDesktopUrl || ''
  const refUsername = branchRefUsername || localRefUsername || ''
  return {
    desktopUrl,
    refUsername,
  }
}

// Clear referral data from preferences
export const clearLocalReferralData = async () => {
  await removePreferences(BranchDataParams.RefUsername)
  await removePreferences(BranchDataParams.DesktopUrl)
}
